import React from 'react';

const WizardContext = React.createContext<null | Object>(null);

export default WizardContext;
